// src/api/mediaKitApi.js
import authService from '../services/AuthService';
import { API_BASE } from '../consts';

// For endpoints that require the logged-in user (mirrors FavoriteButton's pattern)
async function authedReq(url, opts = {}) {
    const res = await authService.authenticatedFetch(url, {
        headers: { 'Content-Type': 'application/json' },
        ...opts,
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Something went wrong.');
    return data;
}

// For the public kit page — no logged-in user, so no auth headers/token needed
async function publicReq(url, opts = {}) {
    const res = await fetch(url, {
        headers: { 'Content-Type': 'application/json' },
        ...opts,
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Something went wrong.');
    return data;
}

async function uploadReq(url, formData) {
    const res = await authService.authenticatedFetch(url, { method: 'POST', body: formData });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Upload failed.');
    return data;
}

export const mediaKitApi = {
    listMine: () => authedReq(`${API_BASE}/api/aip/media-kits`),
    getMine: (kitId) => authedReq(`${API_BASE}/api/aip/media-kit/${kitId}`),
    create: (kit) => authedReq(`${API_BASE}/api/aip/media-kit`, { method: 'POST', body: JSON.stringify(kit) }),
    update: (kitId, patch) => authedReq(`${API_BASE}/api/aip/media-kit/${kitId}`, { method: 'PATCH', body: JSON.stringify(patch) }),
    remove: (kitId) => authedReq(`${API_BASE}/api/aip/media-kit/${kitId}`, { method: 'DELETE' }),
    importStorefront: (storefrontUrl) => authedReq(`${API_BASE}/api/aip/media-kit/import-storefront`, { method: 'POST', body: JSON.stringify({ storefront_url: storefrontUrl }) }),
    uploadImage: (file, prefix = 'mediakit') => {
        const fd = new FormData();
        fd.append('file', file);
        fd.append('prefix', prefix);
        return uploadReq(`${API_BASE}/api/upload/image`, fd);
    },
    save: (kit) => authedReq(`${API_BASE}/api/aip/media-kit`, { method: 'POST', body: JSON.stringify(kit) }),
    checkSlug: (slug) => authedReq(`${API_BASE}/api/aip/media-kit/slug-available?slug=${encodeURIComponent(slug)}`),
    resolveLink: (url) => authedReq(`${API_BASE}/api/aip/media-kit/resolve-link`, { method: 'POST', body: JSON.stringify({ url }) }),
    addVideo: (kitId, video) => authedReq(`${API_BASE}/api/aip/media-kit/${kitId}/videos`, { method: 'POST', body: JSON.stringify(video) }),
    deleteVideo: (kitId, videoId) => authedReq(`${API_BASE}/api/aip/media-kit/${kitId}/videos/${videoId}`, { method: 'DELETE' }),
    reorderVideos: (order) => authedReq(`${API_BASE}/api/aip/media-kit/videos/reorder`, { method: 'PATCH', body: JSON.stringify({ order }) }),
    getAsinVideos: () => authedReq(`${API_BASE}/api/aip/my-asin-counts`),

    // Public — no auth
    getPublic: (slug) => publicReq(`${API_BASE}/api/media-kit/public/${slug}`),
};